module.exports = __webpack_public_path__ + "static/media/01.3829d512.svg";